import React from 'react'

export const IconCross = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.7 6.69999L17.3 5.29999L12 10.6L6.69999 5.29999L5.29999 6.69999L10.6 12L5.29999 17.3L6.69999 18.7L12 13.4L17.3 18.7L18.7 17.3L13.4 12L18.7 6.69999Z" fill="currentColor" />
            <title>Cross</title>
        </svg>
    )
}